<template>

  <!--  <async-select class="x-flex-1" v-model="selectedItem" :api="fGetUserInfo" label-key="user_name"
      value-key="user_id" placeholder="请选择" />
 -->

  <el-select ref="my-select" style="width: 100%;" v-model="selectedValue" filterable remote reserve-keyword
    :disabled="disabled" :placeholder="placeholder" :size="size" @focus="handleRemoteMethod()"
    :remote-method="handleRemoteMethod" @change="handleChange" :loading="loading" :clearable='clearable'
    @clear="handleClear">
    <el-option v-for="item in options" :key="item[valueKey]" :label="item[labelKey]" :value="item[valueKey]">

      <div class="x-flex" v-if='showId'>
        <div class='x-flex-1 x-p-r-20'>{{ item[labelKey] }}</div>
        <!-- 如果valueKey 是cls_id_ex 则显示cls_id 否则显示valueKey -->
        <div class='x-w90'>{{ item[labelKey] == '全部门店' ? '1001' : (valueKey == 'cls_id_ex' ? item['cls_id'] :
          item[valueKey]) }}</div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import API_MAP from "../../common/global/listApi";
export default {
  name: "AsyncSelect",
  props: {
    showAll: {
      type: Boolean,
      default: false
    },
    // 当前选中值
    value: {
      type: [String, Number],
      default: ""
    },
    // 直接传入 API 函数
    api: {
      type: Function,
      default: null
    },
    // 通过名称引用 API
    apiName: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: true
    },
    showId: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "small"
    },
    // label字段名称
    labelKey: {
      type: String,
      default: "label"
    },
    // value字段名称
    valueKey: {
      type: String,
      default: "value"
    },
    // 默认显示文本
    placeholder: {
      type: String,
      default: "请选择"
    },
    initLoad: {
      type: Boolean,
      default: false // 默认不自动加载
    },
    vip_id: {
      type: String,
      default: '' // 默认不自动加载
    },
    cls_id_ex: {
      type: String,
      default: '' // 默认不自动加载
    },
    otherParams: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mall_id: {
      type: String,
      default: '' // 默认不自动加载
    },
  },
  data() {
    return {
      selectedValue: this.value,
      options: [],
      loading: false,
      searchTimer: null,
      checkTimer: null // 用于防抖检查值的定时器
    };
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    },
    selectedValue(newValue) {
      this.$emit("input", newValue);
      // 检查新值是否存在于options中，如果不存在则请求获取
      // 使用防抖避免重复请求
      this.fDebounceCheckValue(newValue);
    }
  },
  async created() {
    // 初始化时加载数据
    // let response = await this.api(this.selectedValue);
    // this.options = response
    if (this.initLoad) {
      await this.loadInitialData();
    }
  },
  async mounted() {
    // let response = await this.api(this.selectedValue);
    // this.options = response
    let rulesDom = this.$refs["my-select"].$el.querySelector(
      ".el-input .el-input__suffix .el-input__suffix-inner .el-input__icon");
    rulesDom.classList.add("el-icon-arrow-up"); // 对dom新增箭头图标
  },
  methods: {
    getApiFunction() {
      // 优先使用直接传入的 API 函数
      if (typeof this.api === 'function') {
        return this.api;
      }

      // 如果传入了 API 名称，使用 API_MAP 中的函数
      if (this.apiName) {
        const apiFunc = API_MAP[this.apiName];
        if (!apiFunc) {
          console.error(`API function ${this.apiName} not found`);
          return () => Promise.resolve([]);
        }
        return apiFunc;
      }

      // 两者都没有提供时的错误处理
      console.error("Either 'api' or 'apiName' must be provided");
      return () => Promise.resolve([]);
    },
    async loadInitialData(query = '') {
      try {
        this.loading = true;
        let otherParams = {
          cls_id_ex: this.cls_id_ex,
          ...this.otherParams
        };
        if (this.apiName == 'GET_VIP_INFO') {
          otherParams.vipId = this.vip_id
          otherParams.mall_id = this.mall_id
        }
        if (this.apiName == 'GET_MALL_INFO') {
          otherParams.showAll = this.showAll
        }
       
        const apiFunc = this.getApiFunction();
        const response = await apiFunc(query, otherParams);

        this.options = response || [];
      } finally {
        this.loading = false;
      }
    },

    handleRemoteMethod(query) {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      let otherParams = {
        cls_id_ex: this.cls_id_ex,
        ...this.otherParams
      };
      console.log(otherParams);
      if (this.apiName == 'GET_VIP_INFO') {
        otherParams.vipId = this.vip_id
        otherParams.mall_id = this.mall_id
      }
      if (this.apiName == 'GET_MALL_INFO') {
        otherParams.showAll = this.showAll
      }
      
      this.loading = true;
      this.searchTimer = setTimeout(async () => {
        try {
          const apiFunc = this.getApiFunction();
          const response = await apiFunc(query, otherParams);
          this.options = response || [];
          // 当搜索结果为空且有查询条件时，触发无结果事件
          if ((response || []).length === 0 && query) {
            this.$emit('no-results', { query, params: otherParams });
          }
        } finally {
          this.loading = false;
        }
      }, 300);
    },
    handleChange(val) {
      this.$emit('change', val)
    },
    // 处理清空选项
    handleClear() {
      this.options = [];
      this.selectedValue = "";
    },

    /**
     * 防抖处理检查值的请求
     * @param {string|number} value - 要检查的值
     */
    fDebounceCheckValue(value) {
      // 清除之前的定时器
      if (this.checkTimer) {
        clearTimeout(this.checkTimer);
      }

      // 设置新的定时器，延迟执行检查
      this.checkTimer = setTimeout(() => {
        this.fCheckAndFetchValue(value);
      }, 200); // 200ms防抖延迟
    },

    /**
     * 检查值是否存在于options中，如果不存在或需要更新则请求API获取
     * @param {string|number} value - 要检查的值
     */
    async fCheckAndFetchValue(value) {
      // 如果值为空，不执行操作
      if (!value || value === '') {
        return;
      }

      // 检查值是否已存在于options中
      const isExist = this.options.some(item => item[this.valueKey] === value);

      // 如果已存在，则不需要再次请求
      if (isExist) {
        return;
      }

      try {
        this.loading = true;
        let otherParams = {
          cls_id_ex: this.cls_id_ex,
          ...this.otherParams
        };
        if (this.apiName == 'GET_VIP_INFO') {
          otherParams.vipId = this.vip_id
        }
        if (this.apiName == 'GET_MALL_INFO') {
          otherParams.showAll = this.showAll
        }
       

        const apiFunc = this.getApiFunction();
        // 使用当前值作为查询参数请求API
        const response = await apiFunc(value, otherParams);

        // 确保response是数组
        const dataArray = Array.isArray(response) ? response : [];

        // 查找返回结果中是否包含当前值
        const matchedItem = dataArray.find(item => item[this.valueKey] === value);

        if (matchedItem) {
          // 先移除可能存在的重复项（避免重复key）
          const newOptions = this.options.filter(item => item[this.valueKey] !== value);
          // 添加新的匹配项到数组开头
          newOptions.unshift(matchedItem);
          // 更新options数组
          this.options = newOptions;
        }
      } catch (error) {
        console.error('获取选中值详情失败:', error);
      } finally {
        this.loading = false;
      }
    }
  },
  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    if (this.checkTimer) {
      clearTimeout(this.checkTimer);
    }
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/x-select-filter.vue